<div class="dropdown-container">
  @if(labelText()) {
    <label class="dropdown-label" [ngStyle]="{ 'color': labelColor() }" for="{{inputId}}">{{ labelText() }}</label>
  } 
  <ng-select
    [labelForId]="inputId()"
    [items]="items()"
    [bindLabel]="bindLabel()"
    [bindValue]="bindValue()"
    [searchFn]="searchFn"
    [(ngModel)]="model"
    [virtualScroll]="true"
    [clearable]="clearable()"
    [multiple]="multiple()"
    [disabled]="disabled()"
    [notFoundText]="notFoundText()"
    [placeholder]="placeholder()"
    [loading]="loading()"
  >
  <ng-template ng-loadingspinner-tmp>
      <dot-loader [small]="true"></dot-loader>
  </ng-template>
  <ng-template ng-loadingtext-tmp>
    <div class="ng-option ng-option-disabled ng-star-inserted">Laddar...</div>
  </ng-template>
  @if(labelTransform) {
    <ng-template ng-option-tmp let-item="item">
      <span>{{ labelTransform(item[bindLabel()]) }}</span>
    </ng-template>
  }


  </ng-select>
</div>
